import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { MediaService } from '../../services/mediaservice/media.service';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from '../../services/dashboardservices/dashboard.service';
import { SharedModeService } from '../../services/shared-mode.service';
import { NewsUpdatesComponent } from '../news-updates/news-updates.component';
import { LoaderComponent } from '../loader/loader.component';
@Component({
  selector: 'app-add-news-updates',
  templateUrl: './add-news-updates.component.html',
  styleUrls: ['./add-news-updates.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class AddNewsUpdatesComponent implements OnInit {
  showSpinner = false;
  fileName: any;
  formData: FormData = new FormData();
  fileExtension: any;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;

  constructor(public datePipe: DatePipe,
    private mediaService: MediaService,
    private router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  onCancel(form: NgForm) {
    form.reset();
  }

  onFileSelected(event: any) {
    this.fileName = '';
    if (event.target.files.length === 0) {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Please select a file.',
        showConfirmButton: false,
        timer: 1500,
      });
    }
    else {
      const fileToUpload = event.target.files[0] as File;
      this.formData.append('media_image', fileToUpload, fileToUpload.name);

      this.fileName = fileToUpload.name;
      this.fileExtension = this.fileName.split('.').pop();
    }
  }

  onSubmit(form: NgForm) {
    if (this.fileName != null && this.fileName != "") {
      const data = form.value;
      data.expiry_date = this.datePipe.transform(data.expiry_date, 'yyyy-MM-dd HH:mm:ss');
      this.formData.append('expiry_date', data.expiry_date);
      this.formData.append('type', data.type);
      this.showSpinner = true;
      this.mediaService
        .addMedia(this.formData)
        .subscribe(response => {
          this.showSpinner = false;
          form.reset();
          if (response.success) {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
              title: 'File Uploaded Successfully!',
              showConfirmButton: false,
              timer: 1500,
            });
          }
          else {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: response.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        },
          error => {
            this.showSpinner = false;
            form.reset();
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: error.error.message,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log('oops', error)
          });
    }
    else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'File format is not valid.',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.user = this.userInfo;
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

  isavailablefeature(type: string): boolean {
    
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.upload_data?.data?.values;

    switch (type) {
      case "view":
        return values?.view ?? false;

      case "upload":
        return values?.accept ?? false;

      case "delete":
        return values?.reject ?? false;


      default:
        return false;
    }
  }




}
